<template>
  <div>
    <div class="mb-1 subtitle-1 font-weight-bold">Categories *</div>
    <v-card outlined tile class="mb-6">
      <v-card-text> 
        <v-row>
          <v-col>
            <v-autocomplete
              :value="value"
              @change="updateValue"
              :items="categorySelection"
              item-text="name"
              item-value="_id"
              chips
              dense
              flat
              small-chips
              multiple
              :rules="categoryRules"
            >
              <template v-slot:selection="{ attrs, item, select }">
                <v-chip
                  color="primary"
                  v-bind="attrs"
                  close
                  class="mt-3 mb-1 mr-1"
                  @click="select"
                  @click:close="removeCategory(item)"
                >{{ item.name }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
// import CategoryCreate from "@/components/Dashboard/CategoryCreate.vue";

import { mapState, mapActions } from "vuex";

export default Vue.extend({
  name: "CategoryForm",
  components: {
    // CategoryCreate
  },
  data() {
    return {
      name: "",
      description: "",
      dialog: false,
      loading: false,
      snackbar: false,
      snackbarText: "",
      categoryRules: [v => v.length > 0 || "At least one Category is required"]
    };
  },
  props: {
    value: [Array]
  },
  computed: {
    ...mapState(["topcategory"]),
    categorySelection() {
      const categories = [];
      this.topcategory.topCategories.forEach(top => {
        categories.push({ header: top.name });
        categories.push(...top.categories);
      });
      return categories;
    }
  },
  methods: {
    ...mapActions(["fetchTopCategories"]),
    removeCategory(item) {
      this.value.splice(this.value.indexOf(item), 1);
    },
    updateValue(event) {
      this.$emit("input", event);
    },
    newCategory(cat) {
      this.$emit("input", [...this.value, cat]);
    }
  },
  mounted() {
    this.fetchTopCategories();
  }
});
</script>

<style lang="scss">
.category {
  margin: 0 0.5em 1em 0;
  display: inline-block;
}
</style>
